module.exports = __webpack_public_path__ + "static/media/clothes-6.6b3e4127.jpg";